import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Routes, routes } from "../../routes";
import PlayerBitmovin from "../../pages/PlayerBitmovin";
import { withAppState, getAppState } from "../../state";

const Main = ({ initialFocus, onRef, setFocus, pauseNavigation, resumeNavigation, logger, from }) => {
  // FIXME: check whether sUC is needed.
  return (
    <Switch>
      {Routes.pages.map(page => {
        const Component = page.component;

        if (page.route === routes.freeTV && getAppState().isSvodUser) {
          return (
            <Route
              exact
              key={window.location.pathname}
              path={page.route}
              render={() => <Redirect to={routes.home} />}
            />
          );
        }

        return (
          <Route
            exact={
              page.route === routes.splash ||
              page.route === routes.series ||
              page.route === `${routes.series}/:titleId` ||
              page.route === `${routes.series}/:titleId/episodes`
            }
            key={window.location.pathname}
            path={page.route}
            render={routeProps => (
              <Component
                {...routeProps}
                {...page}
                initialFocus={initialFocus}
                setFocus={setFocus}
                from={from}
                pauseNavigation={pauseNavigation}
                resumeNavigation={resumeNavigation}
                onRef={onRef}
                logger={logger}
              />
            )}
          />
        );
      })}
      <Route
        exact
        key="player"
        path={routes.player}
        render={props => (
          <PlayerBitmovin
            {...props}
            setFocus={setFocus}
            pauseNavigation={pauseNavigation}
            resumeNavigation={resumeNavigation}
            onRef={onRef}
          />
        )}
      />
    </Switch>
  );
};

export default withAppState(Main);
